<mat-drawer-container autosize>
  <mat-drawer #menuDrawer mode="over">
    <nav app-main-menu></nav>
  </mat-drawer>
  <mat-drawer #cartDrawer mode="over" position="end">
    <aside app-shopping-cart-drawer></aside>
  </mat-drawer>

  <mat-drawer-content>
    <app-main-layout-page></app-main-layout-page>
  </mat-drawer-content>
</mat-drawer-container>
